export const MESSAGES = [
  {
    'ComponentID': '1',
    'MsgType': '0',
    'Name': 'Heartbeat',
    'CategoryID': 'Session',
    'SectionID': 'Session',
    'AbbrName': 'Heartbeat',
    'NotReqXML': '1',
    'Description': 'The Heartbeat monitors the status of the communication link and identifies when the last of a string of messages was not received.',
    'Added': 'FIX.2.7'
  },
  {
    'ComponentID': '2',
    'MsgType': '1',
    'Name': 'TestRequest',
    'CategoryID': 'Session',
    'SectionID': 'Session',
    'AbbrName': 'TestRequest',
    'NotReqXML': '1',
    'Description': 'The test request message forces a heartbeat from the opposing application. The test request message checks sequence numbers or verifies communication line status. The opposite application responds to the Test Request with a Heartbeat containing the TestReqID.',
    'Added': 'FIX.2.7'
  },
  {
    'ComponentID': '3',
    'MsgType': '2',
    'Name': 'ResendRequest',
    'CategoryID': 'Session',
    'SectionID': 'Session',
    'AbbrName': 'ResendRequest',
    'NotReqXML': '1',
    'Description': 'The resend request is sent by the receiving application to initiate the retransmission of messages. This function is utilized if a sequence number gap is detected, if the receiving application lost a message, or as a function of the initialization process.',
    'Added': 'FIX.2.7'
  },
  {
    'ComponentID': '4',
    'MsgType': '3',
    'Name': 'Reject',
    'CategoryID': 'Session',
    'SectionID': 'Session',
    'AbbrName': 'Reject',
    'NotReqXML': '1',
    'Description': 'The reject message should be issued when a message is received but cannot be properly processed due to a session-level rule violation. An example of when a reject may be appropriate would be the receipt of a message with invalid basic data which successfully passes de-encryption, CheckSum and BodyLength checks.',
    'Added': 'FIX.2.7'
  },
  {
    'ComponentID': '5',
    'MsgType': '4',
    'Name': 'SequenceReset',
    'CategoryID': 'Session',
    'SectionID': 'Session',
    'AbbrName': 'SequenceReset',
    'NotReqXML': '1',
    'Description': 'The sequence reset message is used by the sending application to reset the incoming sequence number on the opposing side.',
    'Added': 'FIX.2.7'
  },
  {
    'ComponentID': '6',
    'MsgType': '5',
    'Name': 'Logout',
    'CategoryID': 'Session',
    'SectionID': 'Session',
    'AbbrName': 'Logout',
    'NotReqXML': '1',
    'Description': 'The logout message initiates or confirms the termination of a FIX session. Disconnection without the exchange of logout messages should be interpreted as an abnormal condition.',
    'Added': 'FIX.2.7'
  },
  {
    'ComponentID': '7',
    'MsgType': '6',
    'Name': 'IOI',
    'CategoryID': 'Indication',
    'SectionID': 'PreTrade',
    'AbbrName': 'IOI',
    'NotReqXML': '0',
    'Description': 'Indication of interest messages are used to market merchandise which the broker is buying or selling in either a proprietary or agency capacity. The indications can be time bound with a specific expiration value. Indications are distributed with the understanding that other firms may react to the message first and that the merchandise may no longer be available due to prior trade.\nIndication messages can be transmitted in various transaction types; NEW, CANCEL, and REPLACE. All message types other than NEW modify the state of the message identified in IOIRefID.',
    'Added': 'FIX.2.7'
  },
  {
    'ComponentID': '8',
    'MsgType': '7',
    'Name': 'Advertisement',
    'CategoryID': 'Indication',
    'SectionID': 'PreTrade',
    'AbbrName': 'Adv',
    'NotReqXML': '0',
    'Description': 'Advertisement messages are used to announce completed transactions. The advertisement message can be transmitted in various transaction types; NEW, CANCEL and REPLACE. All message types other than NEW modify the state of a previously transmitted advertisement identified in AdvRefID.',
    'Added': 'FIX.2.7'
  },
  {
    'ComponentID': '9',
    'MsgType': '8',
    'Name': 'ExecutionReport',
    'CategoryID': 'SingleGeneralOrderHandling',
    'SectionID': 'Trade',
    'AbbrName': 'ExecRpt',
    'NotReqXML': '0',
    'Description': 'The execution report message is used to:\n1. confirm the receipt of an order\n2. confirm changes to an existing order (i.e. accept cancel and replace requests)\n3. relay order status information\n4. relay fill information on working orders\n5. relay fill information on tradeable or restricted tradeable quotes\n6. reject orders\n7. report post-trade fees calculations associated with a trade',
    'Added': 'FIX.2.7'
  },
  {
    'ComponentID': '10',
    'MsgType': '9',
    'Name': 'OrderCancelReject',
    'CategoryID': 'SingleGeneralOrderHandling',
    'SectionID': 'Trade',
    'AbbrName': 'OrdCxlRej',
    'NotReqXML': '0',
    'Description': 'The order cancel reject message is issued by the broker upon receipt of a cancel request or cancel/replace request message which cannot be honored.',
    'Added': 'FIX.2.7'
  },
  {
    'ComponentID': '11',
    'MsgType': 'A',
    'Name': 'Logon',
    'CategoryID': 'Session',
    'SectionID': 'Session',
    'AbbrName': 'Logon',
    'NotReqXML': '1',
    'Description': 'The logon message authenticates a user establishing a connection to a remote system. The logon message must be the first message sent by the application requesting to initiate a FIX session.',
    'Added': 'FIX.2.7'
  },
  {
    'ComponentID': '12',
    'MsgType': 'B',
    'Name': 'News',
    'CategoryID': 'EventCommunication',
    'SectionID': 'PreTrade',
    'AbbrName': 'News',
    'NotReqXML': '0',
    'Description': 'The news message is a general free format message between the broker and institution. The message contains flags to identify the news item\'s urgency and to allow sorting by subject company (symbol). The News message can be originated at either the broker or institution side, or exchanges and other marketplace venues.',
    'Added': 'FIX.2.7'
  },
  {
    'ComponentID': '13',
    'MsgType': 'C',
    'Name': 'Email',
    'CategoryID': 'EventCommunication',
    'SectionID': 'PreTrade',
    'AbbrName': 'Email',
    'NotReqXML': '0',
    'Description': 'The email message is similar to the format and purpose of the News message, however, it is intended for private use between two parties.',
    'Added': 'FIX.2.7'
  },
  {
    'ComponentID': '14',
    'MsgType': 'D',
    'Name': 'NewOrderSingle',
    'CategoryID': 'SingleGeneralOrderHandling',
    'SectionID': 'Trade',
    'AbbrName': 'Order',
    'NotReqXML': '0',
    'Description': 'The new order message type is used by institutions wishing to electronically submit securities and forex orders to a broker for execution.\nThe New Order message type may also be used by institutions or retail intermediaries wishing to electronically submit Collective Investment Vehicle (CIV) orders to a broker or fund manager for execution.',
    'Added': 'FIX.2.7'
  },
  {
    'ComponentID': '15',
    'MsgType': 'E',
    'Name': 'NewOrderList',
    'CategoryID': 'ProgramTrading',
    'SectionID': 'Trade',
    'AbbrName': 'NewOrdList',
    'NotReqXML': '0',
    'Description': 'The NewOrderList Message can be used in one of two ways depending on which market conventions are being followed.',
    'Added': 'FIX.2.7'
  },
  {
    'ComponentID': '16',
    'MsgType': 'F',
    'Name': 'OrderCancelRequest',
    'CategoryID': 'SingleGeneralOrderHandling',
    'SectionID': 'Trade',
    'AbbrName': 'OrdCxlReq',
    'NotReqXML': '0',
    'Description': 'The order cancel request message requests the cancellation of all of the remaining quantity of an existing order. Note that the Order Cancel/Replace Request should be used to partially cancel (reduce) an order).',
    'Added': 'FIX.2.7'
  },
  {
    'ComponentID': '17',
    'MsgType': 'G',
    'Name': 'OrderCancelReplaceRequest',
    'CategoryID': 'SingleGeneralOrderHandling',
    'SectionID': 'Trade',
    'AbbrName': 'OrdCxlRplcReq',
    'NotReqXML': '0',
    'Description': 'The order cancel/replace request is used to change the parameters of an existing order.\nDo not use this message to cancel the remaining quantity of an outstanding order, use the Order Cancel Request message for this purpose.',
    'Added': 'FIX.2.7'
  },
  {
    'ComponentID': '18',
    'MsgType': 'H',
    'Name': 'OrderStatusRequest',
    'CategoryID': 'SingleGeneralOrderHandling',
    'SectionID': 'Trade',
    'AbbrName': 'OrdStatReq',
    'NotReqXML': '0',
    'Description': 'The order status request message is used by the institution to generate an order status message back from the broker.',
    'Added': 'FIX.2.7'
  },
  {
    'ComponentID': '19',
    'MsgType': 'J',
    'Name': 'AllocationInstruction',
    'CategoryID': 'Allocation',
    'SectionID': 'PostTrade',
    'AbbrName': 'AllocInstrctn',
    'NotReqXML': '0',
    'Description': 'The Allocation Instruction message provides the ability to specify how an order or set of orders should be subdivided amongst one or more accounts. In versions of FIX prior to version 4.4, this same message was known as the Allocation message. Note in versions of FIX prior to version 4.4, the allocation message was also used to communicate fee and expense details from the Sellside to the Buyside. This role has now been removed from the Allocation Instruction and is now performed by the new (to version 4.4) Allocation Report and Confirmation messages.,The Allocation Report message should be used for the Sell-side Initiated Allocation role as defined in previous versions of the protocol.',
    'Added': 'FIX.2.7'
  },
  {
    'ComponentID': '20',
    'MsgType': 'K',
    'Name': 'ListCancelRequest',
    'CategoryID': 'ProgramTrading',
    'SectionID': 'Trade',
    'AbbrName': 'ListCxlReq',
    'NotReqXML': '0',
    'Description': 'The List Cancel Request message type is used by institutions wishing to cancel previously submitted lists either before or during execution.',
    'Added': 'FIX.2.7'
  },
  {
    'ComponentID': '21',
    'MsgType': 'L',
    'Name': 'ListExecute',
    'CategoryID': 'ProgramTrading',
    'SectionID': 'Trade',
    'AbbrName': 'ListExct',
    'NotReqXML': '0',
    'Description': 'The List Execute message type is used by institutions to instruct the broker to begin execution of a previously submitted list. This message may or may not be used, as it may be mirroring a phone conversation.',
    'Added': 'FIX.2.7'
  },
  {
    'ComponentID': '22',
    'MsgType': 'M',
    'Name': 'ListStatusRequest',
    'CategoryID': 'ProgramTrading',
    'SectionID': 'Trade',
    'AbbrName': 'ListStatReq',
    'NotReqXML': '0',
    'Description': 'The list status request message type is used by institutions to instruct the broker to generate status messages for a list.',
    'Added': 'FIX.2.7'
  },
  {
    'ComponentID': '23',
    'MsgType': 'N',
    'Name': 'ListStatus',
    'CategoryID': 'ProgramTrading',
    'SectionID': 'Trade',
    'AbbrName': 'ListStat',
    'NotReqXML': '0',
    'Description': 'The list status message is issued as the response to a List Status Request message sent in an unsolicited fashion by the sell-side. It indicates the current state of the orders within the list as they exist at the broker\'s site. This message may also be used to respond to the List Cancel Request.',
    'Added': 'FIX.2.7'
  },
  {
    'ComponentID': '24',
    'MsgType': 'P',
    'Name': 'AllocationInstructionAck',
    'CategoryID': 'Allocation',
    'SectionID': 'PostTrade',
    'AbbrName': 'AllocInstrctnAck',
    'NotReqXML': '0',
    'Description': 'In versions of FIX prior to version 4.4, this message was known as the Allocation ACK message.\nThe Allocation Instruction Ack message is used to acknowledge the receipt of and provide status for an Allocation Instruction message.',
    'Added': 'FIX.2.7'
  },
  {
    'ComponentID': '25',
    'MsgType': 'Q',
    'Name': 'DontKnowTrade',
    'CategoryID': 'SingleGeneralOrderHandling',
    'SectionID': 'Trade',
    'AbbrName': 'DkTrd',
    'NotReqXML': '0',
    'Description': 'The Don’t Know Trade (DK) message notifies a trading partner that an electronically received execution has been rejected. This message can be thought of as an execution reject message.',
    'Added': 'FIX.4.0'
  },
  {
    'ComponentID': '26',
    'MsgType': 'R',
    'Name': 'QuoteRequest',
    'CategoryID': 'QuotationNegotiation',
    'SectionID': 'PreTrade',
    'AbbrName': 'QuotReq',
    'NotReqXML': '0',
    'Description': 'In some markets it is the practice to request quotes from brokers prior to placement of an order. The quote request message is used for this purpose. This message is commonly referred to as an Request For Quote (RFQ)',
    'Added': 'FIX.4.0'
  },
  {
    'ComponentID': '27',
    'MsgType': 'S',
    'Name': 'Quote',
    'CategoryID': 'QuotationNegotiation',
    'SectionID': 'PreTrade',
    'AbbrName': 'Quot',
    'NotReqXML': '0',
    'Description': 'The Quote message is used as the response to a Quote Request or a Quote Response message in both indicative, tradeable, and restricted tradeable quoting markets.',
    'Added': 'FIX.4.0'
  },
  {
    'ComponentID': '28',
    'MsgType': 'T',
    'Name': 'SettlementInstructions',
    'CategoryID': 'SettlementInstruction',
    'SectionID': 'PostTrade',
    'AbbrName': 'SettlInstrctns',
    'NotReqXML': '0',
    'Description': 'The Settlement Instructions message provides the broker’s, the institution’s, or the intermediary’s instructions for trade settlement. This message has been designed so that it can be sent from the broker to the institution, from the institution to the broker, or from either to an independent \'standing instructions\' database or matching system or, for CIV, from an intermediary to a fund manager.',
    'Added': 'FIX.4.1'
  },
  {
    'ComponentID': '29',
    'MsgType': 'V',
    'Name': 'MarketDataRequest',
    'CategoryID': 'MarketData',
    'SectionID': 'PreTrade',
    'AbbrName': 'MktDataReq',
    'NotReqXML': '0',
    'Description': 'Some systems allow the transmission of real-time quote, order, trade, trade volume, open interest, and/or other price information on a subscription basis. A Market Data Request is a general request for market data on specific securities or forex quotes.',
    'Added': 'FIX.4.2'
  },
  {
    'ComponentID': '30',
    'MsgType': 'W',
    'Name': 'MarketDataSnapshotFullRefresh',
    'CategoryID': 'MarketData',
    'SectionID': 'PreTrade',
    'AbbrName': 'MktDataFull',
    'NotReqXML': '0',
    'Description': 'The Market Data messages are used as the response to a Market Data Request message. In all cases, one Market Data message refers only to one Market Data Request. It can be used to transmit a 2-sided book of orders or list of quotes, a list of trades, index values, opening, closing, settlement, high, low, or VWAP prices, the trade volume or open interest for a security, or any combination of these.',
    'Added': 'FIX.4.2'
  },
  {
    'ComponentID': '31',
    'MsgType': 'X',
    'Name': 'MarketDataIncrementalRefresh',
    'CategoryID': 'MarketData',
    'SectionID': 'PreTrade',
    'AbbrName': 'MktDataInc',
    'NotReqXML': '0',
    'Description': 'The Market Data message for incremental updates may contain any combination of new, changed, or deleted Market Data Entries, for any combination of instruments, with any combination of trades, imbalances, quotes, index values, open, close, settlement, high, low, and VWAP prices, trade volume and open interest so long as the maximum FIX message size is not exceeded. All of these types of Market Data Entries can be changed and deleted.',
    'Added': 'FIX.4.2'
  },
  {
    'ComponentID': '32',
    'MsgType': 'Y',
    'Name': 'MarketDataRequestReject',
    'CategoryID': 'MarketData',
    'SectionID': 'PreTrade',
    'AbbrName': 'MktDataReqRej',
    'NotReqXML': '0',
    'Description': 'The Market Data Request Reject is used when the broker cannot honor the Market Data Request, due to business or technical reasons. Brokers may choose to limit various parameters, such as the size of requests, whether just the top of book or the entire book may be displayed, and whether Full or Incremental updates must be used.',
    'Added': 'FIX.4.2'
  },
  {
    'ComponentID': '33',
    'MsgType': 'Z',
    'Name': 'QuoteCancel',
    'CategoryID': 'QuotationNegotiation',
    'SectionID': 'PreTrade',
    'AbbrName': 'QuotCxl',
    'NotReqXML': '0',
    'Description': 'The Quote Cancel message is used by an originator of quotes to cancel quotes.\nThe Quote Cancel message supports cancellation of:\n• All quotes\n• Quotes for a specific symbol or security ID\n• All quotes for a security type\n• All quotes for an underlying',
    'Added': 'FIX.4.2'
  },
  {
    'ComponentID': '34',
    'MsgType': 'a',
    'Name': 'QuoteStatusRequest',
    'CategoryID': 'QuotationNegotiation',
    'SectionID': 'PreTrade',
    'AbbrName': 'QuotStatReq',
    'NotReqXML': '0',
    'Description': 'The quote status request message is used for the following purposes in markets that employ tradeable or restricted tradeable quotes:\n• For the issuer of a quote in a market to query the status of that quote (using the QuoteID to specify the target quote).\n• To subscribe and unsubscribe for Quote Status Report messages for one or more securities.',
    'Added': 'FIX.4.2'
  },
  {
    'ComponentID': '35',
    'MsgType': 'b',
    'Name': 'MassQuoteAcknowledgement',
    'CategoryID': 'QuotationNegotiation',
    'SectionID': 'PreTrade',
    'AbbrName': 'MassQuotAck',
    'NotReqXML': '0',
    'Description': 'Mass Quote Acknowledgement is used as the application level response to a Mass Quote message.',
    'Added': 'FIX.4.2'
  },
  {
    'ComponentID': '36',
    'MsgType': 'c',
    'Name': 'SecurityDefinitionRequest',
    'CategoryID': 'SecuritiesReferenceData',
    'SectionID': 'PreTrade',
    'AbbrName': 'SecDefReq',
    'NotReqXML': '0',
    'Description': 'The Security Definition Request message is used for the following:\n1. Request a specific Security to be traded with the second party. The request security can be defined as a multileg security made up of one or more instrument legs.\n2. Request a set of individual securities for a single market segment.\n3. Request all securities, independent of market segment.',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '97',
    'Added': 'FIX.4.2'
  },
  {
    'ComponentID': '37',
    'MsgType': 'd',
    'Name': 'SecurityDefinition',
    'CategoryID': 'SecuritiesReferenceData',
    'SectionID': 'PreTrade',
    'AbbrName': 'SecDef',
    'NotReqXML': '0',
    'Description': 'The Security Definition message is used for the following:\n1. Accept the security defined in a Security Definition message.\n2. Accept the security defined in a Security Definition message with changes to the definition and/or identity of the security.\n3. Reject the security requested in a Security Definition message.\n4. Respond to a request for securities within a specified market segment.\n5. Convey comprehensive security definition for all market segments that the security participates in.\n6. Convey the security\'s trading rules that differ from default rules for the market segment.',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '97',
    'Added': 'FIX.4.2'
  },
  {
    'ComponentID': '38',
    'MsgType': 'e',
    'Name': 'SecurityStatusRequest',
    'CategoryID': 'SecuritiesReferenceData',
    'SectionID': 'PreTrade',
    'AbbrName': 'SecStatReq',
    'NotReqXML': '0',
    'Description': 'The Security Status Request message provides for the ability to request the status of a security. One or more Security Status messages are returned as a result of a Security Status Request message.',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '97',
    'Added': 'FIX.4.2'
  },
  {
    'ComponentID': '39',
    'MsgType': 'f',
    'Name': 'SecurityStatus',
    'CategoryID': 'SecuritiesReferenceData',
    'SectionID': 'PreTrade',
    'AbbrName': 'SecStat',
    'NotReqXML': '0',
    'Description': 'The Security Status message provides for the ability to report changes in status to a security. The Security Status message contains fields to indicate trading status, corporate actions, financial status of the company. The Security Status message is used by one trading entity (for instance an exchange) to report changes in the state of a security.',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '97',
    'Added': 'FIX.4.2'
  },
  {
    'ComponentID': '40',
    'MsgType': 'g',
    'Name': 'TradingSessionStatusRequest',
    'CategoryID': 'MarketStructureReferenceData',
    'SectionID': 'PreTrade',
    'AbbrName': 'TrdgSesStatReq',
    'NotReqXML': '0',
    'Description': 'The Trading Session Status Request is used to request information on the status of a market. With the move to multiple sessions occurring for a given trading party (morning and evening sessions for instance) there is a need to be able to provide information on what product is trading on what market.',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '97',
    'Added': 'FIX.4.2'
  },
  {
    'ComponentID': '41',
    'MsgType': 'h',
    'Name': 'TradingSessionStatus',
    'CategoryID': 'MarketStructureReferenceData',
    'SectionID': 'PreTrade',
    'AbbrName': 'TrdgSesStat',
    'NotReqXML': '0',
    'Description': 'The Trading Session Status provides information on the status of a market. For markets multiple trading sessions on multiple-markets occurring (morning and evening sessions for instance), this message is able to provide information on what products are trading on what market during what trading session.',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '97',
    'Added': 'FIX.4.2'
  },
  {
    'ComponentID': '42',
    'MsgType': 'i',
    'Name': 'MassQuote',
    'CategoryID': 'QuotationNegotiation',
    'SectionID': 'PreTrade',
    'AbbrName': 'MassQuot',
    'NotReqXML': '0',
    'Description': 'The Mass Quote message can contain quotes for multiple securities to support applications that allow for the mass quoting of an option series. Two levels of repeating groups have been provided to minimize the amount of data required to submit a set of quotes for a class of options (e.g. all option series for IBM).',
    'Added': 'FIX.4.2'
  },
  {
    'ComponentID': '43',
    'MsgType': 'j',
    'Name': 'BusinessMessageReject',
    'CategoryID': 'BusinessReject',
    'SectionID': 'Infrastructure',
    'AbbrName': 'BizMsgRej',
    'NotReqXML': '0',
    'Description': 'The Business Message Reject message can reject an application-level message which fulfills session-level rules and cannot be rejected via any other means. Note if the message fails a session-level rule (e.g. body length is incorrect), a session-level Reject message should be issued.',
    'Added': 'FIX.4.2'
  },
  {
    'ComponentID': '44',
    'MsgType': 'k',
    'Name': 'BidRequest',
    'CategoryID': 'ProgramTrading',
    'SectionID': 'Trade',
    'AbbrName': 'BidReq',
    'NotReqXML': '0',
    'Description': 'The BidRequest Message can be used in one of two ways depending on which market conventions are being followed.\n      In the \'Non disclosed\' convention (e.g. US/European model) the BidRequest message can be used to request a bid based on the sector, country, index and liquidity information contained within the message itself. In the \'Non disclosed\' convention the entry repeating group is used to define liquidity of the program. See \' Program/Basket/List Trading\'  for an example.\n      In the \'Disclosed\' convention (e.g. Japanese model) the BidRequest message can be used to request bids based on the ListOrderDetail messages sent in advance of BidRequest message. In the \'Disclosed\' convention the list repeating group is used to define which ListOrderDetail messages a bid is being sort for and the directions of the required bids.',
    'Added': 'FIX.4.2'
  },
  {
    'ComponentID': '45',
    'MsgType': 'l',
    'Name': 'BidResponse',
    'CategoryID': 'ProgramTrading',
    'SectionID': 'Trade',
    'AbbrName': 'BidRsp',
    'NotReqXML': '0',
    'Description': 'The Bid Response message can be used in one of two ways depending on which market conventions are being followed.\n      In the \'Non disclosed\' convention the Bid Response message can be used to supply a bid based on the sector, country, index and liquidity information contained within the corresponding bid request message. See \'Program/Basket/List Trading\'  for an example.\n      In the \'Disclosed\' convention the Bid Response message can be used to supply bids based on the List Order Detail messages sent in advance of the corresponding Bid Request message.',
    'Added': 'FIX.4.2'
  },
  {
    'ComponentID': '46',
    'MsgType': 'm',
    'Name': 'ListStrikePrice',
    'CategoryID': 'ProgramTrading',
    'SectionID': 'Trade',
    'AbbrName': 'ListStrkPx',
    'NotReqXML': '0',
    'Description': 'The strike price message is used to exchange strike price information for principal trades. It can also be used to exchange reference prices for agency trades.',
    'Added': 'FIX.4.2'
  },
  {
    'ComponentID': '47',
    'MsgType': 'n',
    'Name': 'XMLnonFIX',
    'CategoryID': 'Session',
    'SectionID': 'Session',
    'AbbrName': 'XMLnonFIX',
    'NotReqXML': '1',
    'Description': '',
    'Added': 'FIX.4.3'
  },
  {
    'ComponentID': '48',
    'MsgType': 'o',
    'Name': 'RegistrationInstructions',
    'CategoryID': 'RegistrationInstruction',
    'SectionID': 'PostTrade',
    'AbbrName': 'RgstInstrctns',
    'NotReqXML': '0',
    'Description': 'The Registration Instructions message type may be used by institutions or retail intermediaries wishing to electronically submit registration information to a broker or fund manager (for CIV) for an order or for an allocation.',
    'Added': 'FIX.4.3'
  },
  {
    'ComponentID': '49',
    'MsgType': 'p',
    'Name': 'RegistrationInstructionsResponse',
    'CategoryID': 'RegistrationInstruction',
    'SectionID': 'PostTrade',
    'AbbrName': 'RgstInstrctnsRsp',
    'NotReqXML': '0',
    'Description': 'The Registration Instructions Response message type may be used by broker or fund manager (for CIV) in response to a Registration Instructions message submitted by an institution or retail intermediary for an order or for an allocation.',
    'Added': 'FIX.4.3'
  },
  {
    'ComponentID': '50',
    'MsgType': 'q',
    'Name': 'OrderMassCancelRequest',
    'CategoryID': 'OrderMassHandling',
    'SectionID': 'Trade',
    'AbbrName': 'OrdMassCxlReq',
    'NotReqXML': '0',
    'Description': 'The order mass cancel request message requests the cancellation of all of the remaining quantity of a group of orders matching criteria specified within the request. NOTE: This message can only be used to cancel order messages (reduce the full quantity).',
    'Added': 'FIX.4.3'
  },
  {
    'ComponentID': '51',
    'MsgType': 'r',
    'Name': 'OrderMassCancelReport',
    'CategoryID': 'OrderMassHandling',
    'SectionID': 'Trade',
    'AbbrName': 'OrdMassCxlRpt',
    'NotReqXML': '0',
    'Description': 'The Order Mass Cancel Report is used to acknowledge an Order Mass Cancel Request. Note that each affected order that is canceled is acknowledged with a separate Execution Report or Order Cancel Reject message.',
    'Added': 'FIX.4.3'
  },
  {
    'ComponentID': '52',
    'MsgType': 's',
    'Name': 'NewOrderCross',
    'CategoryID': 'CrossOrders',
    'SectionID': 'Trade',
    'AbbrName': 'NewOrdCrss',
    'NotReqXML': '0',
    'Description': 'Used to submit a cross order into a market. The cross order contains two order sides (a buy and a sell). The cross order is identified by its CrossID.',
    'Added': 'FIX.4.3'
  },
  {
    'ComponentID': '53',
    'MsgType': 't',
    'Name': 'CrossOrderCancelReplaceRequest',
    'CategoryID': 'CrossOrders',
    'SectionID': 'Trade',
    'AbbrName': 'CrssOrdCxlRplcReq',
    'NotReqXML': '0',
    'Description': 'Used to modify a cross order previously submitted using the New Order - Cross message. See Order Cancel Replace Request for details concerning message usage.',
    'Added': 'FIX.4.3'
  },
  {
    'ComponentID': '54',
    'MsgType': 'u',
    'Name': 'CrossOrderCancelRequest',
    'CategoryID': 'CrossOrders',
    'SectionID': 'Trade',
    'AbbrName': 'CrssOrdCxlReq',
    'NotReqXML': '0',
    'Description': 'Used to fully cancel the remaining open quantity of a cross order.',
    'Added': 'FIX.4.3'
  },
  {
    'ComponentID': '55',
    'MsgType': 'v',
    'Name': 'SecurityTypeRequest',
    'CategoryID': 'SecuritiesReferenceData',
    'SectionID': 'PreTrade',
    'AbbrName': 'SecTypReq',
    'NotReqXML': '0',
    'Description': 'The Security Type Request message is used to return a list of security types available from a counterparty or market.',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '97',
    'Added': 'FIX.4.3'
  },
  {
    'ComponentID': '56',
    'MsgType': 'w',
    'Name': 'SecurityTypes',
    'CategoryID': 'SecuritiesReferenceData',
    'SectionID': 'PreTrade',
    'AbbrName': 'SecTyps',
    'NotReqXML': '0',
    'Description': 'The Security Type Request message is used to return a list of security types available from a counterparty or market.',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '97',
    'Added': 'FIX.4.3'
  },
  {
    'ComponentID': '57',
    'MsgType': 'x',
    'Name': 'SecurityListRequest',
    'CategoryID': 'SecuritiesReferenceData',
    'SectionID': 'PreTrade',
    'AbbrName': 'SecListReq',
    'NotReqXML': '0',
    'Description': 'The Security List Request message is used to return a list of securities from the counterparty that match criteria provided on the request',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '97',
    'Added': 'FIX.4.3'
  },
  {
    'ComponentID': '58',
    'MsgType': 'y',
    'Name': 'SecurityList',
    'CategoryID': 'SecuritiesReferenceData',
    'SectionID': 'PreTrade',
    'AbbrName': 'SecList',
    'NotReqXML': '0',
    'Description': 'The Security List message is used to return a list of securities that matches the criteria specified in a Security List Request.',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '97',
    'Added': 'FIX.4.3'
  },
  {
    'ComponentID': '59',
    'MsgType': 'z',
    'Name': 'DerivativeSecurityListRequest',
    'CategoryID': 'SecuritiesReferenceData',
    'SectionID': 'PreTrade',
    'AbbrName': 'DerivSecListReq',
    'NotReqXML': '0',
    'Description': 'The Derivative Security List Request message is used to return a list of securities from the counterparty that match criteria provided on the request',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '97',
    'Added': 'FIX.4.3'
  },
  {
    'ComponentID': '60',
    'MsgType': 'AA',
    'Name': 'DerivativeSecurityList',
    'CategoryID': 'SecuritiesReferenceData',
    'SectionID': 'PreTrade',
    'AbbrName': 'DerivSecList',
    'NotReqXML': '0',
    'Description': 'The Derivative Security List message is used to return a list of securities that matches the criteria specified in a Derivative Security List Request.',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '97',
    'Added': 'FIX.4.3'
  },
  {
    'ComponentID': '61',
    'MsgType': 'AB',
    'Name': 'NewOrderMultileg',
    'CategoryID': 'MultilegOrders',
    'SectionID': 'Trade',
    'AbbrName': 'NewOrdMleg',
    'NotReqXML': '0',
    'Description': 'The New Order - Multileg is provided to submit orders for securities that are made up of multiple securities, known as legs.',
    'Added': 'FIX.4.3'
  },
  {
    'ComponentID': '62',
    'MsgType': 'AC',
    'Name': 'MultilegOrderCancelReplace',
    'CategoryID': 'MultilegOrders',
    'SectionID': 'Trade',
    'AbbrName': 'MlegOrdCxlRplc',
    'NotReqXML': '0',
    'Description': 'Used to modify a multileg order previously submitted using the New Order - Multileg message. See Order Cancel Replace Request for details concerning message usage.',
    'Added': 'FIX.4.3'
  },
  {
    'ComponentID': '63',
    'MsgType': 'AD',
    'Name': 'TradeCaptureReportRequest',
    'CategoryID': 'TradeCapture',
    'SectionID': 'PostTrade',
    'AbbrName': 'TrdCaptRptReq',
    'NotReqXML': '0',
    'Description': 'The Trade Capture Report Request can be used to:\n• Request one or more trade capture reports based upon selection criteria provided on the trade capture report request\n• Subscribe for trade capture reports based upon selection criteria provided on the trade capture report request.',
    'Added': 'FIX.4.3'
  },
  {
    'ComponentID': '64',
    'MsgType': 'AE',
    'Name': 'TradeCaptureReport',
    'CategoryID': 'TradeCapture',
    'SectionID': 'PostTrade',
    'AbbrName': 'TrdCaptRpt',
    'NotReqXML': '0',
    'Description': 'The Trade Capture Report message can be:\n• Used to report trades between counterparties.\n• Used to report trades to a trade matching system\n• Can be sent unsolicited between counterparties.\n• Sent as a reply to a Trade Capture Report Request.\n• Can be used to report unmatched and matched trades.',
    'Added': 'FIX.4.3'
  },
  {
    'ComponentID': '65',
    'MsgType': 'AF',
    'Name': 'OrderMassStatusRequest',
    'CategoryID': 'OrderMassHandling',
    'SectionID': 'Trade',
    'AbbrName': 'OrdMassStatReq',
    'NotReqXML': '0',
    'Description': 'The order mass status request message requests the status for orders matching criteria specified within the request.',
    'Added': 'FIX.4.3'
  },
  {
    'ComponentID': '66',
    'MsgType': 'AG',
    'Name': 'QuoteRequestReject',
    'CategoryID': 'QuotationNegotiation',
    'SectionID': 'PreTrade',
    'AbbrName': 'QuotReqRej',
    'NotReqXML': '0',
    'Description': 'The Quote Request Reject message is used to reject Quote Request messages for all quoting models.',
    'Added': 'FIX.4.3'
  },
  {
    'ComponentID': '67',
    'MsgType': 'AH',
    'Name': 'RFQRequest',
    'CategoryID': 'QuotationNegotiation',
    'SectionID': 'PreTrade',
    'AbbrName': 'RFQReq',
    'NotReqXML': '0',
    'Description': 'In tradeable and restricted tradeable quoting markets – Quote Requests are issued by counterparties interested in ascertaining the market for an instrument. Quote Requests are then distributed by the market to liquidity providers who make markets in the instrument. The RFQ Request is used by liquidity providers to indicate to the market for which instruments they are interested in receiving Quote Requests. It can be used to register interest in receiving quote requests for a single instrument or for multiple instruments',
    'Added': 'FIX.4.3'
  },
  {
    'ComponentID': '68',
    'MsgType': 'AI',
    'Name': 'QuoteStatusReport',
    'CategoryID': 'QuotationNegotiation',
    'SectionID': 'PreTrade',
    'AbbrName': 'QuotStatRpt',
    'NotReqXML': '0',
    'Description': 'The quote status report message is used:\n• as the response to a Quote Status Request message\n• as a response to a Quote Cancel message\n• as a response to a Quote Response message in a negotiation dialog (see Volume 7 – PRODUCT: FIXED INCOME and USER GROUP: EXCHANGES AND MARKETS)',
    'Added': 'FIX.4.3'
  },
  {
    'ComponentID': '69',
    'MsgType': 'AJ',
    'Name': 'QuoteResponse',
    'CategoryID': 'QuotationNegotiation',
    'SectionID': 'PreTrade',
    'AbbrName': 'QuotRsp',
    'NotReqXML': '0',
    'Description': 'The Quote Response message is used to respond to a IOI message or Quote message. It is also used to counter a Quote or end a negotiation dialog.',
    'Added': 'FIX.4.4'
  },
  {
    'ComponentID': '70',
    'MsgType': 'AK',
    'Name': 'Confirmation',
    'CategoryID': 'Confirmation',
    'SectionID': 'PostTrade',
    'AbbrName': 'Cnfm',
    'NotReqXML': '0',
    'Description': 'The Confirmation messages are used to provide individual trade level confirmations from the sell side to the buy side. In versions of FIX prior to version 4.4, this role was performed by the allocation message. Unlike the allocation message, the confirmation message operates at an allocation account (trade) level rather than block level, allowing for the affirmation or rejection of individual confirmations.',
    'Added': 'FIX.4.4'
  },
  {
    'ComponentID': '71',
    'MsgType': 'AL',
    'Name': 'PositionMaintenanceRequest',
    'CategoryID': 'PositionMaintenance',
    'SectionID': 'PostTrade',
    'AbbrName': 'PosMntReq',
    'NotReqXML': '0',
    'Description': 'The Position Maintenance Request message allows the position owner to submit requests to the holder of a position which will result in a specific action being taken which will affect the position. Generally, the holder of the position is a central counter party or clearing organization but can also be a party providing investment services.',
    'Added': 'FIX.4.4'
  },
  {
    'ComponentID': '72',
    'MsgType': 'AM',
    'Name': 'PositionMaintenanceReport',
    'CategoryID': 'PositionMaintenance',
    'SectionID': 'PostTrade',
    'AbbrName': 'PosMntRpt',
    'NotReqXML': '0',
    'Description': 'The Position Maintenance Report message is sent by the holder of a positon in response to a Position Maintenance Request and is used to confirm that a request has been successfully processed or rejected.',
    'Added': 'FIX.4.4'
  },
  {
    'ComponentID': '73',
    'MsgType': 'AN',
    'Name': 'RequestForPositions',
    'CategoryID': 'PositionMaintenance',
    'SectionID': 'PostTrade',
    'AbbrName': 'ReqForPoss',
    'NotReqXML': '0',
    'Description': 'The Request For Positions message is used by the owner of a position to request a Position Report from the holder of the position, usually the central counter party or clearing organization. The request can be made at several levels of granularity.',
    'Added': 'FIX.4.4'
  },
  {
    'ComponentID': '74',
    'MsgType': 'AO',
    'Name': 'RequestForPositionsAck',
    'CategoryID': 'PositionMaintenance',
    'SectionID': 'PostTrade',
    'AbbrName': 'ReqForPossAck',
    'NotReqXML': '0',
    'Description': 'The Request for Positions Ack message is returned by the holder of the position in response to a Request for Positions message. The purpose of the message is to acknowledge that a request has been received and is being processed.',
    'Added': 'FIX.4.4'
  },
  {
    'ComponentID': '75',
    'MsgType': 'AP',
    'Name': 'PositionReport',
    'CategoryID': 'PositionMaintenance',
    'SectionID': 'PostTrade',
    'AbbrName': 'PosRpt',
    'NotReqXML': '0',
    'Description': 'The Position Report message is returned by the holder of a position in response to a Request for Position message. The purpose of the message is to report all aspects of a position and may be provided on a standing basis to report end of day positions to an owner.',
    'Added': 'FIX.4.4'
  },
  {
    'ComponentID': '76',
    'MsgType': 'AQ',
    'Name': 'TradeCaptureReportRequestAck',
    'CategoryID': 'TradeCapture',
    'SectionID': 'PostTrade',
    'AbbrName': 'TrdCaptRptReqAck',
    'NotReqXML': '0',
    'Description': 'The Trade Capture Request Ack message is used to:\n• Provide an acknowledgement to a Trade Capture Report Request in the case where the Trade Capture Report Request is used to specify a subscription or delivery of reports via an out-of-band ResponseTransmissionMethod.\n• Provide an acknowledgement to a Trade Capture Report Request in the case when the return of the Trade Capture Reports matching that request will be delayed or delivered asynchronously. This is useful in distributed trading system environments.\n• Indicate that no trades were found that matched the selection criteria specified on the Trade Capture Report Request\n• The Trade Capture Request was invalid for some business reason, such as request is not authorized, invalid or unknown instrument, party, trading session, etc.',
    'Added': 'FIX.4.4'
  },
  {
    'ComponentID': '77',
    'MsgType': 'AR',
    'Name': 'TradeCaptureReportAck',
    'CategoryID': 'TradeCapture',
    'SectionID': 'PostTrade',
    'AbbrName': 'TrdCaptRptAck',
    'NotReqXML': '0',
    'Description': 'The Trade Capture Report Ack message can be:\n• Used to acknowledge trade capture reports received from a counterparty\n• Used to reject a trade capture report received from a counterparty',
    'Added': 'FIX.4.4'
  },
  {
    'ComponentID': '78',
    'MsgType': 'AS',
    'Name': 'AllocationReport',
    'CategoryID': 'Allocation',
    'SectionID': 'PostTrade',
    'AbbrName': 'AllocRpt',
    'NotReqXML': '0',
    'Description': 'Sent from sell-side to buy-side, sell-side to 3rd-party or 3rd-party to buy-side, the Allocation Report (Claim) provides account breakdown of an order or set of orders plus any additional follow-up front-office information developed post-trade during the trade allocation, matching and calculation phase. In versions of FIX prior to version 4.4, this functionality was provided through the Allocation message. Depending on the needs of the market and the timing of \'confirmed\' status, the role of Allocation Report can be taken over in whole or in part by the Confirmation message.',
    'Added': 'FIX.4.4'
  },
  {
    'ComponentID': '79',
    'MsgType': 'AT',
    'Name': 'AllocationReportAck',
    'CategoryID': 'Allocation',
    'SectionID': 'PostTrade',
    'AbbrName': 'AllocRptAck',
    'NotReqXML': '0',
    'Description': 'The Allocation Report Ack message is used to acknowledge the receipt of and provide status for an Allocation Report message.',
    'Added': 'FIX.4.4'
  },
  {
    'ComponentID': '80',
    'MsgType': 'AU',
    'Name': 'ConfirmationAck',
    'CategoryID': 'Confirmation',
    'SectionID': 'PostTrade',
    'AbbrName': 'CnfmAck',
    'NotReqXML': '0',
    'Description': 'The Confirmation Ack (aka Affirmation) message is used to respond to a Confirmation message.',
    'Added': 'FIX.4.4'
  },
  {
    'ComponentID': '81',
    'MsgType': 'AV',
    'Name': 'SettlementInstructionRequest',
    'CategoryID': 'SettlementInstruction',
    'SectionID': 'PostTrade',
    'AbbrName': 'SettlInstrctnReq',
    'NotReqXML': '0',
    'Description': 'The Settlement Instruction Request message is used to request standing settlement instructions from another party.',
    'Added': 'FIX.4.4'
  },
  {
    'ComponentID': '82',
    'MsgType': 'AW',
    'Name': 'AssignmentReport',
    'CategoryID': 'PositionMaintenance',
    'SectionID': 'PostTrade',
    'AbbrName': 'AsgnRpt',
    'NotReqXML': '0',
    'Description': 'Assignment Reports are sent from a clearing house to counterparties, such as a clearing firm as a result of the assignment process.',
    'Added': 'FIX.4.4'
  },
  {
    'ComponentID': '83',
    'MsgType': 'AX',
    'Name': 'CollateralRequest',
    'CategoryID': 'CollateralManagement',
    'SectionID': 'PostTrade',
    'AbbrName': 'CollReq',
    'NotReqXML': '0',
    'Description': 'An initiator that requires collateral from a respondent sends a Collateral Request. The initiator can be either counterparty to a trade in a two party model or an intermediary such as an ATS or clearinghouse in a three party model. A Collateral Assignment is expected as a response to a request for collateral.',
    'Added': 'FIX.4.4'
  },
  {
    'ComponentID': '84',
    'MsgType': 'AY',
    'Name': 'CollateralAssignment',
    'CategoryID': 'CollateralManagement',
    'SectionID': 'PostTrade',
    'AbbrName': 'CollAsgn',
    'NotReqXML': '0',
    'Description': 'Used to assign collateral to cover a trading position. This message can be sent unsolicited or in reply to a Collateral Request message.',
    'Added': 'FIX.4.4'
  },
  {
    'ComponentID': '85',
    'MsgType': 'AZ',
    'Name': 'CollateralResponse',
    'CategoryID': 'CollateralManagement',
    'SectionID': 'PostTrade',
    'AbbrName': 'CollRsp',
    'NotReqXML': '0',
    'Description': 'Used to respond to a Collateral Assignment message.',
    'Added': 'FIX.4.4'
  },
  {
    'ComponentID': '86',
    'MsgType': 'BA',
    'Name': 'CollateralReport',
    'CategoryID': 'CollateralManagement',
    'SectionID': 'PostTrade',
    'AbbrName': 'CollRpt',
    'NotReqXML': '0',
    'Description': 'Used to report collateral status when responding to a Collateral Inquiry message.',
    'Added': 'FIX.4.4'
  },
  {
    'ComponentID': '87',
    'MsgType': 'BB',
    'Name': 'CollateralInquiry',
    'CategoryID': 'CollateralManagement',
    'SectionID': 'PostTrade',
    'AbbrName': 'CollInq',
    'NotReqXML': '0',
    'Description': 'Used to inquire for collateral status.',
    'Added': 'FIX.4.4'
  },
  {
    'ComponentID': '88',
    'MsgType': 'BC',
    'Name': 'NetworkCounterpartySystemStatusRequest',
    'CategoryID': 'Network',
    'SectionID': 'Infrastructure',
    'AbbrName': 'NtwkSysStatReq',
    'NotReqXML': '0',
    'Description': 'This message is send either immediately after logging on to inform a network (counterparty system) of the type of updates required or to at any other time in the FIX conversation to change the nature of the types of status updates required. It can also be used with a NetworkRequestType of Snapshot to request a one-off report of the status of a network (or counterparty) system. Finally this message can also be used to cancel a request to receive updates into the status of the counterparties on a network by sending a NetworkRequestStatusMessage with a NetworkRequestType of StopSubscribing.',
    'Added': 'FIX.4.4'
  },
  {
    'ComponentID': '89',
    'MsgType': 'BD',
    'Name': 'NetworkCounterpartySystemStatusResponse',
    'CategoryID': 'Network',
    'SectionID': 'Infrastructure',
    'AbbrName': 'NtwkSysStatRsp',
    'NotReqXML': '0',
    'Description': 'This message is sent in response to a Network (Counterparty System) Status Request Message.',
    'Added': 'FIX.4.4'
  },
  {
    'ComponentID': '90',
    'MsgType': 'BE',
    'Name': 'UserRequest',
    'CategoryID': 'UserManagement',
    'SectionID': 'Infrastructure',
    'AbbrName': 'UserReq',
    'NotReqXML': '0',
    'Description': 'This message is used to initiate a user action, logon, logout or password change. It can also be used to request a report on a user\'s status.',
    'Added': 'FIX.4.4'
  },
  {
    'ComponentID': '91',
    'MsgType': 'BF',
    'Name': 'UserResponse',
    'CategoryID': 'UserManagement',
    'SectionID': 'Infrastructure',
    'AbbrName': 'UserRsp',
    'NotReqXML': '0',
    'Description': 'This message is used to respond to a user request message, it reports the status of the user after the completion of any action requested in the user request message.',
    'Added': 'FIX.4.4'
  },
  {
    'ComponentID': '92',
    'MsgType': 'BG',
    'Name': 'CollateralInquiryAck',
    'CategoryID': 'CollateralManagement',
    'SectionID': 'PostTrade',
    'AbbrName': 'CollInqAck',
    'NotReqXML': '0',
    'Description': 'Used to respond to a Collateral Inquiry in the following situations:\n• When the CollateralInquiry will result in an out of band response (such as a file transfer).\n• When the inquiry is otherwise valid but no collateral is found to match the criteria specified on the Collateral Inquiry message.\n• When the Collateral Inquiry is invalid based upon the business rules of the counterparty.',
    'Added': 'FIX.4.4'
  },
  {
    'ComponentID': '93',
    'MsgType': 'BH',
    'Name': 'ConfirmationRequest',
    'CategoryID': 'Confirmation',
    'SectionID': 'PostTrade',
    'AbbrName': 'CnfmReq',
    'NotReqXML': '0',
    'Description': 'The Confirmation Request message is used to request a Confirmation message.',
    'Added': 'FIX.4.4'
  },
  {
    'ComponentID': '94',
    'MsgType': 'BO',
    'Name': 'ContraryIntentionReport',
    'CategoryID': 'PositionMaintenance',
    'SectionID': 'PostTrade',
    'AbbrName': 'ContIntRpt',
    'NotReqXML': '0',
    'Description': 'The Contrary Intention Report is used for reporting of contrary expiration quantities for Saturday expiring options. This information is required by options exchanges for regulatory purposes.',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'ComponentID': '95',
    'MsgType': 'BP',
    'Name': 'SecurityDefinitionUpdateReport',
    'CategoryID': 'SecuritiesReferenceData',
    'SectionID': 'PreTrade',
    'AbbrName': 'SecDefUpd',
    'NotReqXML': '0',
    'Description': 'This message is used for reporting updates to a Product Security Masterfile. Updates could be the result of corporate actions or other business events. Updates may include additions, modifications or deletions.',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '97',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'ComponentID': '96',
    'MsgType': 'BK',
    'Name': 'SecurityListUpdateReport',
    'CategoryID': 'SecuritiesReferenceData',
    'SectionID': 'PreTrade',
    'AbbrName': 'SecListUpd',
    'NotReqXML': '0',
    'Description': 'The Security List Update Report is used for reporting updates to a Contract Security Masterfile. Updates could be due to Corporate Actions or other business events. Update may include additions, modifications and deletions.',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '97',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'ComponentID': '97',
    'MsgType': 'BL',
    'Name': 'AdjustedPositionReport',
    'CategoryID': 'PositionMaintenance',
    'SectionID': 'PostTrade',
    'AbbrName': 'AdjPosRep',
    'NotReqXML': '0',
    'Description': 'Used to report changes in position, primarily in equity options, due to modifications to the underlying due to corporate actions',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'ComponentID': '98',
    'MsgType': 'BM',
    'Name': 'AllocationInstructionAlert',
    'CategoryID': 'Allocation',
    'SectionID': 'PostTrade',
    'AbbrName': 'AllocInstrAlert',
    'NotReqXML': '0',
    'Description': 'This message is used in a 3-party allocation model where notification of group creation and group updates to counterparties is needed. The mssage will also carry trade information that comprised the group to the counterparties.',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'ComponentID': '99',
    'MsgType': 'BN',
    'Name': 'ExecutionAcknowledgement',
    'CategoryID': 'SingleGeneralOrderHandling',
    'SectionID': 'Trade',
    'AbbrName': 'ExecAck',
    'NotReqXML': '0',
    'Description': 'The Execution Report Acknowledgement message is an optional message that provides dual functionality to notify a trading partner that an electronically received execution has either been accepted or rejected (DK\'d).',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'ComponentID': '100',
    'MsgType': 'BJ',
    'Name': 'TradingSessionList',
    'CategoryID': 'MarketStructureReferenceData',
    'SectionID': 'PreTrade',
    'AbbrName': 'TradSessList',
    'NotReqXML': '0',
    'Description': 'The Trading Session List message is sent as a response to a Trading Session List Request. The Trading Session List should contain the characteristics of the trading session and the current state of the trading session.',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '97',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'ComponentID': '101',
    'MsgType': 'BI',
    'Name': 'TradingSessionListRequest',
    'CategoryID': 'MarketStructureReferenceData',
    'SectionID': 'PreTrade',
    'AbbrName': 'TradSessListReq',
    'NotReqXML': '0',
    'Description': 'The Trading Session List Request is used to request a list of trading sessions available in a market place and the state of those trading sessions. A successful request will result in a response from the counterparty of a Trading Session List (MsgType=BJ) message that contains a list of zero or more trading sessions.',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '97',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'ComponentID': '102',
    'MsgType': 'BQ',
    'Name': 'SettlementObligationReport',
    'CategoryID': 'SettlementInstruction',
    'SectionID': 'PostTrade',
    'AbbrName': 'SettlObligation',
    'NotReqXML': '0',
    'Description': 'The Settlement Obligation Report message provides a central counterparty, institution, or individual counterparty with a capacity for reporting the final details of a currency settlement obligation.',
    'Added': 'FIX.5.0',
    'AddedEP': '-1'
  },
  {
    'ComponentID': '103',
    'MsgType': 'BR',
    'Name': 'DerivativeSecurityListUpdateReport',
    'CategoryID': 'SecuritiesReferenceData',
    'SectionID': 'PreTrade',
    'AbbrName': 'DerivSecListUpd',
    'NotReqXML': '0',
    'Description': 'The Derivative Security List Update Report message is used to send updates to an option family or the strikes that comprise an option family.',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '97',
    'Added': 'FIX.5.0',
    'AddedEP': '-1'
  },
  {
    'ComponentID': '104',
    'MsgType': 'BS',
    'Name': 'TradingSessionListUpdateReport',
    'CategoryID': 'MarketStructureReferenceData',
    'SectionID': 'PreTrade',
    'AbbrName': 'TrdgSesListUpd',
    'NotReqXML': '0',
    'Description': 'The Trading Session List Update Report is used by marketplaces to provide intra-day updates of trading sessions when there are changes to one or more trading sessions.',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '97',
    'Added': 'FIX.5.0',
    'AddedEP': '-1'
  },
  {
    'ComponentID': '105',
    'MsgType': 'BT',
    'Name': 'MarketDefinitionRequest',
    'CategoryID': 'MarketStructureReferenceData',
    'SectionID': 'PreTrade',
    'AbbrName': 'MktDefReq',
    'NotReqXML': '0',
    'Description': 'The Market Definition Request message is used to request for market structure information from the Respondent that receives this request.',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '97',
    'Added': 'FIX.5.0',
    'AddedEP': '-1'
  },
  {
    'ComponentID': '106',
    'MsgType': 'BU',
    'Name': 'MarketDefinition',
    'CategoryID': 'MarketStructureReferenceData',
    'SectionID': 'PreTrade',
    'AbbrName': 'MktDef',
    'NotReqXML': '0',
    'Description': 'The Market Definition message is used to respond to Market Definition Request. In a subscription, it will be used to provide the initial snapshot of the information requested. Subsequent updates are provided by the Market Definition Update Report.',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '97',
    'Added': 'FIX.5.0',
    'AddedEP': '-1'
  },
  {
    'ComponentID': '107',
    'MsgType': 'BV',
    'Name': 'MarketDefinitionUpdateReport',
    'CategoryID': 'MarketStructureReferenceData',
    'SectionID': 'PreTrade',
    'AbbrName': 'MktDefUpd',
    'NotReqXML': '0',
    'Description': 'In a subscription for market structure information, this message is used once the initial snapshot of the information has been sent using the Market Definition message.',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '97',
    'Added': 'FIX.5.0',
    'AddedEP': '-1'
  },
  {
    'ComponentID': '113',
    'MsgType': 'CB',
    'Name': 'UserNotification',
    'CategoryID': 'UserManagement',
    'SectionID': 'Infrastructure',
    'AbbrName': 'UserNotifctn',
    'NotReqXML': '0',
    'Description': 'The User Notification message is used to notify one or more users of an event or information from the sender of the message. This message is usually sent unsolicited from a marketplace (e.g. Exchange, ECN) to a market participant.',
    'Added': 'FIX.5.0',
    'AddedEP': '-1'
  },
  {
    'ComponentID': '111',
    'MsgType': 'BZ',
    'Name': 'OrderMassActionReport',
    'CategoryID': 'OrderMassHandling',
    'SectionID': 'Trade',
    'AbbrName': 'OrdMassActRpt',
    'NotReqXML': '0',
    'Description': 'The Order Mass Action Report is used to acknowledge an Order Mass Action Request. Note that each affected order that is suspended or released or canceled is acknowledged with a separate Execution Report for each order.',
    'Added': 'FIX.5.0',
    'AddedEP': '-1'
  },
  {
    'ComponentID': '112',
    'MsgType': 'CA',
    'Name': 'OrderMassActionRequest',
    'CategoryID': 'OrderMassHandling',
    'SectionID': 'Trade',
    'AbbrName': 'OrdMassActReq',
    'NotReqXML': '0',
    'Description': 'The Order Mass Action Request message can be used to request the suspension or release of a group of orders that match the criteria specified within the request. This is equivalent to individual Order Cancel Replace Requests for each order with or without adding \'S\' to the ExecInst values. It can also be used for mass order cancellation.',
    'Added': 'FIX.5.0',
    'AddedEP': '-1'
  },
  {
    'ComponentID': '108',
    'MsgType': 'BW',
    'Name': 'ApplicationMessageRequest',
    'CategoryID': 'Application',
    'SectionID': 'Infrastructure',
    'AbbrName': 'ApplMsgReq',
    'NotReqXML': '0',
    'Description': 'This message is used to request a retransmission of a set of one or more messages generated by the application specified in RefApplID (1355).',
    'Added': 'FIX.5.0',
    'AddedEP': '-1'
  },
  {
    'ComponentID': '109',
    'MsgType': 'BX',
    'Name': 'ApplicationMessageRequestAck',
    'CategoryID': 'Application',
    'SectionID': 'Infrastructure',
    'AbbrName': 'ApplMsgReqAck',
    'NotReqXML': '0',
    'Description': 'This message is used to acknowledge an Application Message Request providing a status on the request (i.e. whether successful or not). This message does not provide the actual content of the messages to be resent.',
    'Added': 'FIX.5.0',
    'AddedEP': '-1'
  },
  {
    'ComponentID': '110',
    'MsgType': 'BY',
    'Name': 'ApplicationMessageReport',
    'CategoryID': 'Application',
    'SectionID': 'Infrastructure',
    'AbbrName': 'ApplMsgRpt',
    'NotReqXML': '0',
    'Description': 'This message is used for three difference purposes: to reset the ApplSeqNum (1181) of a specified ApplID (1180). to indicate that the last message has been sent for a particular ApplID, or as a keep-alive mechanism for ApplIDs with infrequent message traffic.',
    'Added': 'FIX.5.0',
    'AddedEP': '-1'
  },
  {
    'ComponentID': '114',
    'MsgType': 'CC',
    'Name': 'StreamAssignmentRequest',
    'CategoryID': 'MarketData',
    'SectionID': 'PreTrade',
    'AbbrName': 'StrmAsgnReq',
    'NotReqXML': '0',
    'Description': 'In certain markets where market data aggregators fan out to end clients the pricing streams provided by the price makers, the price maker may assign the clients to certain pricing streams that the price maker publishes via the aggregator. An example of this use is in the FX markets where clients may be assigned to different pricing streams based on volume bands and currency pairs.',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '93'
  },
  {
    'ComponentID': '115',
    'MsgType': 'CD',
    'Name': 'StreamAssignmentReport',
    'CategoryID': 'MarketData',
    'SectionID': 'PreTrade',
    'AbbrName': 'StrmAsgnRpt',
    'NotReqXML': '0',
    'Description': 'he StreamAssignmentReport message is in response to the StreamAssignmentRequest message. It provides information back to the aggregator as to which clients to assign to receive which price stream based on requested CCY pair. This message can be sent unsolicited to the Aggregator from the Price Maker.',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '93'
  },
  {
    'ComponentID': '116',
    'MsgType': 'CE',
    'Name': 'StreamAssignmentReportACK',
    'CategoryID': 'MarketData',
    'SectionID': 'PreTrade',
    'AbbrName': 'StrmAsgnRptACK',
    'NotReqXML': '0',
    'Description': 'This message is used to respond to the Stream Assignment Report, to either accept or reject an unsolicited assingment.',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '93'
  }
];